import script from "./TemplatePreviewDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./TemplatePreviewDialog.vue?vue&type=script&setup=true&lang=ts"

import "./TemplatePreviewDialog.vue?vue&type=style&index=0&id=bda8bf9a&lang=scss&scoped=true"
import "./TemplatePreviewDialog.vue?vue&type=style&index=1&id=bda8bf9a&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bda8bf9a"]])

export default __exports__